<template>
  <div>
    <div class="box info-box">
      <div class="box-header with-border">
          <h3 class="box-title text-warning">Profit-Loss</h3>
      </div>
      <!-- /.box-header -->
      <div class="box-body">
          <table class="table table-sm table-bordered table-striped table-hover">
            <thead>
              <tr>
                <td>Total Income</td>
                <td><strong>₹</strong>{{indInc}}/-</td>
              </tr>
              <tr>
                <td>Total Expense</td>
                <td><strong>₹</strong>{{indExp}}/-</td>
              </tr>
            </thead>
          </table>
                
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'profitloss',
  data () {
    return {
      isLoading: false,
      indInc: 0,
      indExp: 0,
      plRecords: ''
    }
  },
  methods: {
    profitLossRecord () {
      var ii = 0
      var ie = 0
      var indirectIncome = []
      var indirectExpense = []
      var c = JSON.parse(localStorage.user)
      if (c.type === 'admin') {
        this.$axios
        .get('profitloss', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          indirectExpense = data[2]
          indirectIncome = data[3]
          _.forEach(indirectIncome.ledgers, function (value, key) {
            ii += _.sumBy(value.br_ledgers, function (o) { return o.cr_amt })
          })
          this.indInc = ii
          _.forEach(indirectExpense.ledgers, function (value, key) {
            ie += _.sumBy(value.br_ledgers, function (o) { return o.dr_amt })
          })
          this.indExp = ie
        })
        .catch(function (error) {
          console.log(error)
        })
      }
    }
  },
  created () {
    this.profitLossRecord()
  }
}
</script>
<style scoped>
.info-box {
    border-radius:10px;
    box-shadow: 0px 0px 4px gray;
  }
</style>



// WEBPACK FOOTER //
// ProfitLoss.vue?fb72613e